var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"surveyConfirmation"},[_c('el-card',{style:({width: _vm.dialogWidth}),attrs:{"body-style":{padding: '70px'}}},[_c('h2',[_vm._v("Your answers have been saved")]),_c('p',[_vm._v("Thank you for you participation")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }